import { Outlet, useNavigate } from "react-router-dom";
import React, { useEffect, useReducer, useState, } from "react";

import CookieConsent from "../cookieconsent";
import Navbar2 from "../navbar2";
import { TopArrow } from "./TopArrow";

import {
    getMixpanelTrackingStatus,
    allowCookies,
    termsConditionsURL,
    trackAction,
  } from "../../services/mixpanel"

import {
    getAllActivities,
    getAllTrails,
    getStripeLevel,
    unitLabels,
    } from "../../services";

import { reducerUserContext } from "./ActivitiesLayout.reducer";

const userInitialState = {
    isUserLoggedIn: false,
    allowedCookies: false,
    userStripeLevel: null,
    userPrefUnits: unitLabels(),
    activityUuid: null,
    activityId: null,
    // do we move the context creation to the navbar instead? userPrefs: {summaryUnitLabels: unitLabels(), stripeLevel:  },
  };

export function ActivitiesLayout() {
    // This is loaded ALL times, independent of whether an activity has been selected or not
    const [userState, dispatch] = useReducer(reducerUserContext, userInitialState);
    const [activities, setActivities] = useState([]);
    const [trails, setTrails] = useState(null);
    const navigate = useNavigate();
    const [refreshActivities, setRefreshActivities ] = useState(false);
    const { isUserLoggedIn } = userState;
    
    const updateActivities = async () => {
      await getAllActivities().then((result) => {
        setActivities(() => [...result]);
        console.log(`ActivitiesLayout - getAllActivities: ${result.length} activities loaded`)
      });
    };
  
    const updateTrails = () => {
      getAllTrails().then((result) => {
        setTrails(result);
      });
    };
  
    const updateStripeLevel = () => {
      getStripeLevel()
        .then((res) => {
          dispatch({ type: "SET_STRIPE_LEVEL", payload: res });
          dispatch({ type: "SET_USER_LOGGED_IN", payload: true });
          setRefreshActivities(true);
        })
        .catch((err) => {
          console.log(err);
          dispatch({ type: "SET_USER_LOGGED_IN", payload: false });
        });
      };
    
    // 1. Update userContext
    useEffect(() => {
        dispatch({ type: "SET_COOKIES_ALLOWANCE", payload: getMixpanelTrackingStatus() });
        dispatch({ type: "SET_PREF_UNITS", payload: unitLabels() });
        updateStripeLevel();
    }, []);

    // fetch user activities on page load
    useEffect(() => {
      if (isUserLoggedIn && refreshActivities) {
        console.log("Debug: Activities Layout initial load of activities - only if user logged in!");
        updateActivities();
        updateTrails();
        setRefreshActivities(false);
      }
    }, [isUserLoggedIn, refreshActivities]);

    const handleCookieAllowance = () => {
      if (allowCookies()) {
        dispatch({ type: "SET_COOKIES_ALLOWANCE", payload: true });
      };
    };

    const handleActivityChange = (e) => {
      trackAction("Select existing activity", userState.allowedCookies);
      dispatch({ type: "SET_ACTIVITY_UUID", payload: e.uuid });
      dispatch({ type: "SET_ACTIVITY_ID", payload: e.value });
      navigate('/plan/activity/' + e.uuid);
    };
  
    const handleActivityAdd = async (activityUuid) => {
      trackAction("Add new activity", userState.allowedCookies);
      console.log("Debug: ActivityLayout: enter activityAddV2");
      setRefreshActivities(true);
      dispatch({ type: "SET_ACTIVITY_UUID", payload: activityUuid });
      navigate('/plan/activity/' + activityUuid);
    };

    return (
      <>
        <Navbar2
            listOfActivities={activities}
            selectedActivity={userState.activityId}
            trails={trails}
            onChange={handleActivityChange}
            handleActivityAdd={handleActivityAdd}
            isUserLoggedIn={userState.isUserLoggedIn}
            userStripeLevel={userState.userStripeLevel}
        />
        <TopArrow />
        <CookieConsent 
            getMixpanelTrackingStatus={userState.allowedCookies}
            termsConditionsURL={termsConditionsURL}
            handleCookieAllowance={handleCookieAllowance}
            />
        <Outlet context={[userState, dispatch]}/>
      </>
    );
}
